import {Component, ViewEncapsulation} from "@angular/core";
import { AuthenticationService } from "./services/authentication.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    constructor(private authService: AuthenticationService) {
        this.authService.loggedInUser$.subscribe(user => {
            if (user) {
                this.authService.validateSession().catch(err => {
                    this.authService.setLoggedUser(null);
                    console.error(err);
                });
            }
        });

        window.addEventListener("storage", this.storageEventListener.bind(this));
    }

    private storageEventListener(event: StorageEvent) {
        if (event.storageArea == localStorage) {
            this.authService.setLoggedUser(this.authService.getUserFromStorage());
        }
    }
}
